export default __webpack_public_path__ + "static/media/choose-2.c2fd2d1b.png";